import { render, staticRenderFns } from "./driverOrderList.vue?vue&type=template&id=5f428a44&"
import script from "./driverOrderList.vue?vue&type=script&lang=js&"
export * from "./driverOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports